import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FundLogo } from '../../../../components/custom/FundLogo';
import StatusCircle from '../../../../components/custom/StatusCircle';
import BoxesIcon from '../../../../components/icons/BoxesIcon';
import FundsSidebar from './FundsSidebar';

interface ItemProps {
  products: any;
  fundName: string;
}

const Item = ({ products, fundName }: ItemProps) => {
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <TableRow
        sx={{
          backgroundColor: '#FFF',
          borderRadius: '10px',
          '&:last-child td, &:last-child th': { border: 0 },
          boxShadow: 'none',
          cursor: 'pointer',
        }}
        onClick={toggleSidebar}
      >
        <TableCell
          sx={{
            padding: '20px',
            borderBottom: 'none',
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
            textAlign: 'right',
            width: '170px',
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            gap={1}
            sx={{
              height: '50px',
              background: '#F3F5F7',
              borderRadius: '10px',
              pt: '7px',
              px: '10px',
            }}
          >
            <FundLogo logoIndex={fundName} width="100px" height="50px" />
            <Stack direction="row" gap={1}>
              <BoxesIcon />
              <Stack>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                  color="#808080"
                >
                  {products.length}
                </Typography>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                  color="#808080"
                >
                  מוצרים מקושרים
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </TableCell>
        <TableCell
          sx={{
            padding: '20px',
            borderBottom: 'none',
            textAlign: 'right',
            width: '130px',
          }}
        >
          <Stack
            direction="row"
            gap={3}
            spacing={2}
            sx={{
              height: '50px',
              background: '#F3F5F7',
              borderRadius: '10px',
              pt: '7px',
              px: '10px',
            }}
          >
            <Stack direction="row" alignItems="center">
              <Typography
                fontSize="14px"
                fontWeight="700"
                fontFamily={'AlmoniDL'}
              >
                סך הכל:&nbsp;
              </Typography>
              <Typography
                fontSize="14px"
                fontWeight="700"
                fontFamily={'AlmoniDL'}
              >
                0
              </Typography>
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              flex={1}
              justifyContent={'space-between'}
            >
              <Stack direction="row" alignItems="center">
                <Box ml={1}>
                  <StatusCircle status="COMPLETED" />
                </Box>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  הצלחה:&nbsp;
                </Typography>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  0
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Box ml={1}>
                  <StatusCircle status="IN_PROGRESS" />
                </Box>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  בתהליך:&nbsp;
                </Typography>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  0
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Box ml={1}>
                  <StatusCircle status="REJECTED" />
                </Box>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  כישלון:&nbsp;
                </Typography>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  0
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </TableCell>

        <TableCell
          sx={{
            width: '200px',
            padding: '20px',
            borderBottom: 'none',
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
          }}
        >
          <Stack direction="row-reverse" gap={1.5}>
            <Box
              sx={{
                background: '#F3F5F7',
                borderRadius: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                px: '10px',
                height: '40px',
              }}
            >
              <Stack direction="row-reverse" alignItems="center" gap={1}>
                <img alt="arrow" src="/assets/file/employees/arrow.svg" />
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  מוצרים
                </Typography>
              </Stack>
            </Box>

            <Box
              sx={{
                background: '#F3F5F7',
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <img
                src="/assets/file/download.svg"
                style={{ cursor: 'pointer', width: '55px' }}
              />
            </Box>
          </Stack>
        </TableCell>
      </TableRow>{' '}
      <FundsSidebar
        fundName={fundName}
        products={products}
        open={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />
    </>
  );
};

export default Item;
